import * as z from "zod/v4";

const emailChannelStatsSchema = z.object({
  messagesSent: z.number(),
  openRate: z.number(),
  clickRate: z.number(),
});

const smsChannelStatsSchema = z.object({
  messagesSent: z.number(),
  clickRate: z.number(),
});

const groupMessageStatsSchema = z.object({
  email: emailChannelStatsSchema,
  sms: smsChannelStatsSchema,
});

export const getMarketingAgentSplitTestMessageStats = {
  name: "getMarketingAgentSplitTestMessageStats" as const,
  input: z.object({
    teamId: z.string(),
    splitId: z.string(),
    days: z.number(),
  }),
  output: z
    .object({
      variant: groupMessageStatsSchema,
      control: groupMessageStatsSchema,
    })
    .nullable(),
};
